import { render, staticRenderFns } from "./mixin.vue?vue&type=template&id=38a500b0&scoped=true&"
import script from "./mixin.vue?vue&type=script&lang=js&"
export * from "./mixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a500b0",
  null
  
)

export default component.exports